import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Card, CardContent, Typography, Divider, Box } from "@mui/material";

interface Product {
  deliveryMethod: string;
}

interface Order {
  id: string;
  title: string;
  deliverDate: string;
  city: string;
  address: string;
  OrderNr: number;
  status: string;
  products: Product[];
  DeliveryMethod: string;
  paymentMethod: string;
}
function ShipementCard({ order }: { order: Order }) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const DeleveryCompanies = [
    ...new Set(order.products.map((product) => product.deliveryMethod)),
  ];
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        boxShadow: "none",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#1a1a1a",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          🚚 {t("delivery.shipmentDetails")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("delivery.shippingCompany")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {DeleveryCompanies.length > 0
                ? DeleveryCompanies.join(", ")
                : t("delivery.notSpecified")}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("delivery.shippingDate")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {new Date(order.deliverDate).toLocaleDateString()}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("checkout.fields.shippingAddress")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {order.address}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default ShipementCard;
